import _ from 'underscore';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';

export const entitySeparator = '-------------------------';

export const formatInvalidEntities = ({
  InvalidEntities,
  ValidEntities,
}: {
  InvalidEntities: string[];
  ValidEntities: string[];
}): string => _.compact(_.union(InvalidEntities, _.isEmpty(ValidEntities) ? [] : [entitySeparator], ValidEntities)).join('\r\n');

const getExclusionCount = exclusionData => _.compact(exclusionData.split(/\r?\n/)).length;

export const getSummary = (level, exclusionData, i18n) => {
  if (level === ScopeLevel.Campaign) {
    const siteExclusions = _.result(exclusionData && exclusionData.campaignExclusions, 'ExcludedSites', '');
    const ipExclusions = _.result(exclusionData && exclusionData.campaignExclusions, 'ExcludedIPs', '');
    const siteExclusionsCount = getExclusionCount(siteExclusions);
    const ipExclusionsCount = getExclusionCount(ipExclusions);
    return i18n.getString(_TL_('{{siteExclusionsCount}} website(s) excluded at the ad level. {{ipExclusionsCount}} IP address(es) excluded at the ad level.'), { siteExclusionsCount, ipExclusionsCount });
  }

  const siteExclusions = _.result(exclusionData && exclusionData.adgroupExclusions, 'ExcludedSites', '');
  const campaignReadOnlySiteExclusions = _.result(exclusionData && exclusionData.campaignExclusions, 'ExcludedSites', '');
  const adgroupLevelExclusionCount = getExclusionCount(siteExclusions);
  const campaignLevelExclusionCount = getExclusionCount(campaignReadOnlySiteExclusions);
  return i18n.getString(_TL_('{{adgroupLevelExclusionCount}} website(s) excluded at the ad level. {{campaignLevelExclusionCount}} website(s) excluded at the campaign level.'), { adgroupLevelExclusionCount, campaignLevelExclusionCount });
};
